module.exports = __webpack_public_path__ + "img/arrow_up.20988da8.svg";